export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "search.worker-85cbaed6c33463625760.worker.js");
}
